import * as React from 'react'
import {connect} from "react-redux"
import {ApplicationState} from "../../store"
import {Button, FormControl, InputLabel, MenuItem, Select, Paper, Grid, Divider, List, ListItem, ListItemIcon, ListItemText, Checkbox, IconButton} from "@material-ui/core"
import SaveIcon from "@material-ui/icons/Save"
import DeleteIcon from '@material-ui/icons/Delete'
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab"
import {actionUserDelete, actionUserFetch, actionUserSave} from "../../store/users/actions"
import {actionRoleFetchAll} from "../../store/roles"
import {Role, DepartmentRole} from "../../models/Role"
import {Utility} from "../../core/Utility"
import {actionActiveTabTitle, actionDeleteTab} from "../../store/tabs/actions"
import {DeleteConfirmation} from "../components/DeleteConfirmation"
import {Tab} from "../Tab"
import {Validator} from "../../core/Validator"
import {UserDescriptor} from "../../models/User"
import {PopupDialog} from "../../core/components/PopupDialog"
import {AppCookies} from "../../core/Cookies"
import {t} from "../../core/localization"
import {Position} from "../../models/Position"
import {Department} from "../../models/Department"
import {actionDepartmentsFetchAll} from "../../store/departments"
import {Permissions} from "../../core/auth/Permissions"
import PermissionContainer from "../../core/auth/PermissionContainer"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {LookupDataRow} from "../../services/LookupDataRow"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {FieldView} from "../components/FieldView"
import {userFieldsDescriptor} from "./UserFields"

export interface UserTabProps extends BaseTabProps{
	roles: Role[]
	tab: Tab
	positions: Position[]
	departments: Department[]
}

export interface UserTabState extends BaseTabState{
	isDeleteConfirmationDialogOpen: boolean,
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any,
	grantedRoles: string[],
	unauthorizedRoles: string[],
	checkedRoles: string[]
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		roles: state.roles.list,
		tab: state.tabs.active,
		positions: state.positions.list,
		departments: state.departments.list
	}
}

class UserTab extends BaseTab<UserTabProps, UserTabState> {

	constructor(props: UserTabProps) {
		super(props)
		this.state = {
			isDeleteConfirmationDialogOpen: false,
			isDialogOpen: false, dialogText: '',
			dialogTitle: '',
			validation: {valid: true, fields: []},
			grantedRoles: (Utility.formatGrantedRoles(this.getObjectItemFromTabState('roles'), this.getItemFromTabState('departmentId'), this.props.roles)),
			unauthorizedRoles: (Utility.formatUngrantedRoles(this.getObjectItemFromTabState('roles'), this.getItemFromTabState('departmentId'), this.props.roles)),
			checkedRoles: []
		}
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: UserTabProps) {
	}

	componentDidMount() {
		actionRoleFetchAll()
		actionDepartmentsFetchAll()
		if (this.props.item.id) actionUserFetch(this.props.item)
		AppCookies.getAccessToken()
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '10px'}}>
				{this.renderTabControls()}
				<div style={{display:'flex', flexDirection:'row', flex:'2', marginTop: '10px' }}>
					<div style={{flex:'1', marginRight: '20px'}}>
						<Paper style={{padding:'10px'}}>
							{this.renderForm()}
							{this.renderFormControls()}
						</Paper>
					</div>
					<div style={{flex:'1'}}>
						<PermissionContainer hasAnyPermission={[Permissions.USERS_EDIT]} >
							<Paper style={{padding:'10px'}}>
								{/*{this.props.item.id && <FileUploader*/}
								{/*	itemId={this.props.item.id}*/}
								{/*	itemType={'Users'}*/}
								{/*	uploads={this.props.item.uploads}*/}
								{/*	onUpload={this.onUpload.bind(this)}*/}
								{/*	onDelete={this.onFileDelete.bind(this)}/>}*/}
								{/*{!this.props.item.id && <p style={{textAlign: 'center'}}>Save item to be able to upload documents</p>}*/}
								{this.renderForm2()}
							</Paper>
						</PermissionContainer>
					</div>
				</div>
				{this.renderDeleteConfirmationDialog()}
				{this.renderPopupDialog()}
			</div>
		)
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = userFieldsDescriptor

		return (<div className="create-form">
		{
			descriptor && descriptor.createFormFields.map(
				(entityField: EntityField<any>, index: number) => {
					const fieldName = entityField.name.toString()
					let value = Utility.formatString(this.getItemFromTabState(fieldName))
					return (
						<div style={{ marginBottom: "0px", padding: "0px" }}>
							{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
									lookupData={this.getLookupData.bind(this)}
								/>}
							</div>
						)
					}
				)
			}
		</div>
		)
	}

	renderForm2(): React.ReactNode {
		let allRoles:Role[] = this.props.roles
		let allDepartments:Department[] = this.props.departments
		let activeDepartment:string = this.getItemFromTabState('departmentId')
		let activeRoles:string[] = []
		let departmentRoles = this.getObjectItemFromTabState('roles')
		if (!Array.isArray(this.getObjectItemFromTabState('roles'))) {
			departmentRoles = []
		}
		for(let item of departmentRoles){
			if(item.departmentId == activeDepartment){
				for(let itemOfRoles of allRoles){
					if(itemOfRoles.id == item.roleId){
						activeRoles.push(itemOfRoles.name)
					}
				}
			}
		}
		let unactiveRoles:string[] = []
		for(let item of allRoles){
			let founded = false
			for(let itemOfRoles of departmentRoles){
				if(itemOfRoles.roleId==item.id && itemOfRoles.departmentId==activeDepartment){
					founded=true
				}
			}
			if(!founded){
				unactiveRoles.push(item.name)
			}
		}
		let allOfDepartments = this.props.departments
		allOfDepartments.push({id:'all',description:null,parentId:null,title:'Svi sektori'})
		allOfDepartments = allOfDepartments.reduce((unique, o) => { //removed duplicated
			if(!unique.some((obj:any) => obj.id === o.id && obj.title === o.title)) {
				unique.push(o)
			}
			return unique
		},[])
		return <form className='ev-form' noValidate autoComplete="on">{}
			<FormControl required style={{width: '100%', marginTop:'20px'}} >
				<InputLabel htmlFor="age-required">Sektor</InputLabel>
				<Select
					value={Utility.formatString(this.getItemFromTabState('departmentId'))}
					onChange={(e) => {
						this.handleItemSelectChange(e, 'departmentId')
						this.setState({ ...this.state,
						grantedRoles: (Utility.formatGrantedRoles(this.getObjectItemFromTabState('roles'), this.getItemFromTabState('departmentId'), this.props.roles)),
						unauthorizedRoles: (Utility.formatUngrantedRoles(this.getObjectItemFromTabState('roles'), this.getItemFromTabState('departmentId'), this.props.roles))
					})
					}}
					name="departmentId"
					required={true}
					style={{width: '100%'}}>
					{allOfDepartments.map((department, key) => (
					<MenuItem key={key} value={department.id}>{department.title}</MenuItem>
					))}
				</Select>
			</FormControl>
				<Grid container spacing={2} justify="center" alignItems="center" style={{marginTop:"10px"}}>
					<Grid item>
					<Paper style={{margin:"10px",width:"250px",height:"300px",overflow:"auto"}}>
						<InputLabel htmlFor="age-required" style={{margin:"10px",textAlign:"center"}}>{t.Roles}</InputLabel>
						<Divider />
						<List dense component="div" role="list">
							{this.state.unauthorizedRoles.map((value: string) => {
							return (
								<ListItem key={value} role="listitem" button onClick={
									() => {
										const currentIndex = this.state.checkedRoles.indexOf(value);
										const newChecked = [...this.state.checkedRoles];
										if (currentIndex === -1) {
											newChecked.push(value)
										} else {
											newChecked.splice(currentIndex, 1)
										}
										this.setState({ ...this.state, checkedRoles: newChecked})
										}
									}>
								<ListItemIcon>
									<Checkbox checked={this.state.checkedRoles.indexOf(value) !== -1} tabIndex={-1} disableRipple/>
								</ListItemIcon>
								<ListItemText primary={value} />
								</ListItem>
								)
								})}
						</List>
					</Paper>
					</Grid>
					<Grid item>
						<Grid container direction="column" alignItems="center">
						<Button variant="outlined" size="small" onClick={
							async ()=>{
								const leftChecked: string[] = Utility.intersection(this.state.checkedRoles, this.state.unauthorizedRoles)
								const newUnauthorizedRoles: string[] = Utility.not(this.state.unauthorizedRoles, leftChecked)
								await	this.setState({unauthorizedRoles:newUnauthorizedRoles})
								let newGrantedRoles: string[] = [...this.state.grantedRoles].concat(leftChecked)
								await	this.setState({grantedRoles:newGrantedRoles})
								const newCheckedRoles = Utility.not(this.state.checkedRoles, leftChecked)
								await	this.setState({checkedRoles:newCheckedRoles})
								await this.handleItemRoleChange(this.state.grantedRoles,
									this.getObjectItemFromTabState('roles'),
									activeDepartment, allRoles, allDepartments, 'roles')
								}
						}
						disabled={Utility.intersection(this.state.checkedRoles, this.state.unauthorizedRoles).length === 0} aria-label="move selected right">
							&gt;</Button>
						<Button variant="outlined" size="small" onClick={
							async ()=>{
								const rightChecked: string[] = Utility.intersection(this.state.checkedRoles, this.state.grantedRoles)
								const newGrantedRoles: string[] = Utility.not(this.state.grantedRoles, rightChecked)
								await this.setState({grantedRoles:newGrantedRoles})
								let newUnauthorizedRoles: string[] = [...this.state.unauthorizedRoles].concat(rightChecked)
								await this.setState({unauthorizedRoles:newUnauthorizedRoles})
								const newCheckedRoles = Utility.not(this.state.checkedRoles, rightChecked)
								await this.setState({checkedRoles:newCheckedRoles})
								await this.handleItemRoleChange(this.state.grantedRoles,
									this.getObjectItemFromTabState('roles'),
									activeDepartment, allRoles, allDepartments, 'roles')
								}
						}
						disabled={Utility.intersection(this.state.checkedRoles, this.state.grantedRoles).length === 0}  aria-label="move selected left">
							&lt;</Button>
						</Grid>
					</Grid>
					<Grid item>
						<Paper style={{margin:"10px",width:"250px",height:"300px",overflow:"auto"}}>
							<InputLabel htmlFor="age-required" style={{margin:"10px",textAlign:"center"}}>{t.GrantedRoles}</InputLabel>
							<Divider />
							<List dense component="div" role="list">
							{this.state.grantedRoles.map((value: string) => {
							return (
								<ListItem key={value} role="listitem" button onClick={
									() => {
										const currentIndex = this.state.checkedRoles.indexOf(value)
										const newChecked = [...this.state.checkedRoles]
										if (currentIndex === -1) {
											newChecked.push(value)
										} else {
											newChecked.splice(currentIndex, 1)
										}
										this.setState({ ...this.state, checkedRoles: newChecked})
										}
									}>
								<ListItemIcon>
									<Checkbox checked={this.state.checkedRoles.indexOf(value) !== -1} tabIndex={-1} disableRipple/>
								</ListItemIcon>
								<ListItemText primary={value} />
								</ListItem>
								)
								})}
							</List>
						</Paper>
					</Grid>
				</Grid>
		</form>
	}

	getLookupData(lookupEntity: LookupEntities): LookupDataRow[] {
		switch (lookupEntity) {
			case LookupEntities.Roles: {
				return this.props.roles.map((role: Role) => {return {label: `${role.name}`, value: role.id, data: role}})
			}
			case LookupEntities.Positions: {
				return this.props.positions.map((position: Position) => {return {label: `${position.title}`, value: position.id, data: position}})
			}
		}
	}

	renderFormControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />Save</Button>
			</div>
	}

	renderTabControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={this.openDeleteConfirmationModal.bind(this)}>
				<DeleteIcon />
			</IconButton>
		</div>
	}

	renderDeleteConfirmationDialog(): React.ReactNode {
		return <DeleteConfirmation
			isOpen={this.state.isDeleteConfirmationDialogOpen}
			onDeleteConfirm={() => this.onDeleteConfirmClick()}
			onToggleModal={() => this.onToggleDeleteConfirmationModal()}
		/>
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	onSaveClick () {
		let itemToSave = this.getItemFromTabState()

		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, UserDescriptor)
		if (validation.valid) {
			actionUserSave(itemToSave)
			actionActiveTabTitle('User: ' + this.getItemFromTabState('firstName'))
		}

		this.setState({ ...this.state, validation})
	}

	onUpload () {
		actionUserFetch(this.props.item)
	}

	onFileDelete () {
		actionUserFetch(this.props.item)
	}

	openDeleteConfirmationModal() {
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: true})
	}

	onToggleDeleteConfirmationModal(){
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: !this.state.isDeleteConfirmationDialogOpen})
	}

	onDeleteConfirmClick(){
		actionUserDelete(this.props.item)
		actionDeleteTab(this.props.tab)
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}
}

export default connect(mapStateToProps)(UserTab)
